// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__IIUXo","head":"Table_head__1HjG1","col":"Table_col__2T1IW"};